// What a farmer is told about a layer that is slow or missing (BBB-457).
//
// Every farmer-facing string for layer status lives here rather than scattered
// through JSX, so the wording can be changed in one pass.
//
// Rules it is written against: plain words, no jargon, and never blame the farmer
// or their connection, because we do not know whose fault it is. "Not available
// right now" is deliberately about the data rather than the app, and deliberately
// says nothing about why: `arcgisQuery.js` can tell a dead server from an empty
// answer, but the health signal here is tile outcomes, which cannot.
//
// `partial` is absent on purpose. The vector path publishes it when it hits its
// page cap, and what a farmer should be shown for a layer that drew most of the
// designations is still an open decision (see useVectorLayerController). Showing
// nothing is the honest placeholder; inventing a line for it would quietly close
// a question nobody has answered.

const LINES = {
  loading: 'Loading',
  slow: 'Still loading, this one is slow',
  unavailable: 'Not available right now',
};

/**
 * @param {string|undefined} status
 * @returns {string|null} the line to show under the layer name, or null for silence
 */
export function layerStatusLine(status) {
  return LINES[status] ?? null;
}

/** Whether a status should read as a problem rather than as progress. */
export function isProblemStatus(status) {
  return status === 'unavailable';
}
